import React from 'react';
import {
    Container,
    Grid,
    Typography,
    makeStyles
} from '@material-ui/core';
import Page from 'components/Page';
import { useTranslation } from "react-i18next";
import AddressesTable from './AddressesTable';

const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

export default function AddressesListView() {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Page
            className={classes.root}
            title={t('navbar.addresses')}
        >
            <Container maxWidth={false}>
                <Typography variant="h1" gutterBottom >
                    {t('navbar.addresses')}
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <AddressesTable/>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
}